import { motion } from "framer-motion";
import type { ScreenConfig } from "../../shared/protocol.ts";

/** RAFED welcome screen; greeting and service names remain gateway-owned. */
export function IdleScreen({ config }: { config: ScreenConfig }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="rafed-idle flex h-full flex-col items-center justify-center px-[8vw] text-center"
    >
      <img src="/brand/rafed-logo.svg" alt="رافد RAFED" className="rafed-idle-logo" />

      {config.headline ? (
        <h1
          dir="auto"
          className="text-[clamp(30px,4vw,64px)] font-black leading-tight"
        >
          {config.headline}
        </h1>
      ) : null}

      {config.subheadline ? (
        <p
          dir="auto"
          className="mt-5 max-w-3xl text-[clamp(15px,1.5vw,26px)] leading-loose text-dim"
        >
          {config.subheadline}
        </p>
      ) : null}

      {config.chips.length > 0 ? (
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {config.chips.map((name, i) => (
            <motion.span
              key={name}
              dir="auto"
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15 * i + 0.2, duration: 0.5 }}
              className="rafed-idle-chip rounded-full px-5 py-2
                         text-[clamp(13px,1.2vw,20px)] font-bold backdrop-blur"
            >
              {name}
            </motion.span>
          ))}
        </div>
      ) : null}

      {config.hint ? (
        <p dir="auto" className="mt-12 text-[clamp(12px,1.1vw,19px)] rafed-idle-hint">
          {config.hint}
        </p>
      ) : null}
    </motion.div>
  );
}
